import {CsvModel} from "../../util/CSVWriteUtil";
import {OfficeVisitSheetRow} from "../../api/Model";
import {ContractorRef, ContractorVisitSheet} from "../../api/ContractorVisitStore";
import {EmployeeVisitType, isEmployeeVisit} from "../../api/EmployeeVisitStore";
import {isWeekend} from "../../util/DateUtil";

export function defaultContractorVisitReportName(date: Date = new Date()): string {
    return `contractor_visits_${date.toISOString()}.csv`;
}

export function downloadContractorVisitCsv(
    sheet: ContractorVisitSheet,
    reportName = defaultContractorVisitReportName(),
) {
    const workDayIndices = sheet.dates
        .map((date, index) => ({date, index}))
        .filter(({date}) => !isWeekend(date))
        .map(({index}) => index);
    const model = new CsvModel<OfficeVisitSheetRow<ContractorRef, EmployeeVisitType>>([
        {header: 'Contractor', value: row => row.value.fullName},
        {header: 'Company', value: row => row.value.company ?? ''},
        ...sheet.dates.map((date, dateIndex) => ({
            header: date,
            value: (row: OfficeVisitSheetRow<ContractorRef, EmployeeVisitType>) =>
                isEmployeeVisit(row.visits[dateIndex]) ? '1' : '0',
        })),
        {
            header: 'Total',
            value: row => row.visits.filter(isEmployeeVisit).length.toString(),
        },
        {
            header: 'Total %',
            value: row => {
                const visits = workDayIndices.filter(index => row.visits[index] === EmployeeVisitType.WorkDayVisit).length;
                return workDayIndices.length === 0 ? '—' : `${Math.round(visits / workDayIndices.length * 100)}%`;
            },
        },
    ]);
    const trimmedName = reportName.trim();
    const fileName = trimmedName || defaultContractorVisitReportName();
    model.downloadCsv(fileName.endsWith('.csv') ? fileName : `${fileName}.csv`, sheet.rows);
}
